import React from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';

import { badgesContainer, badge } from './scss/Badges.module.scss';

const Badges = ({ items }) => {
  return (
    <div className={badgesContainer}>
      {items.map(item => (
        <span key={shortid()} className={badge}>
          {item}
        </span>
      ))}
    </div>
  );
};

Badges.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string),
};

Badges.defaultProps = {
  items: [],
};

export default Badges;
